module.exports = __webpack_public_path__ + "static/media/Сar-placeholder.8ac478a2.svg";